/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Sync_Changes_Error_ToastInputs */

const en_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const fr_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de la synchronisation des modifications. ${i?.error}`)
};

const de_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beim Synchronisieren der Änderungen ist ein Fehler aufgetreten. ${i?.error}`)
};

const it_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore durante la sincronizzazione delle modifiche. ${i?.error}`)
};

const ru_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Произошла ошибка синхронизации изменений. ${i?.error}`)
};

const es_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hubo un error al sincronizar los cambios. ${i?.error}`)
};

const zh_cn2_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`同步更改时出错。${i?.error}`)
};

const ja_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`変更の同期中にエラーが発生しました。${i?.error}`)
};

const hi_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`परिवर्तनों को सिंक्रनाइज़ करने में त्रुटि हुई। ${i?.error}`)
};

const pt_pt2_sync_changes_error_toast = /** @type {(inputs: Sync_Changes_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro ao sincronizar as alterações. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "There was an error syncing changes. {error}" |
*
* @param {Sync_Changes_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_error_toast = /** @type {((inputs: Sync_Changes_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_error_toast(inputs)
	if (locale === "de") return de_sync_changes_error_toast(inputs)
	if (locale === "it") return it_sync_changes_error_toast(inputs)
	if (locale === "ru") return ru_sync_changes_error_toast(inputs)
	if (locale === "es") return es_sync_changes_error_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_error_toast(inputs)
	if (locale === "ja") return ja_sync_changes_error_toast(inputs)
	if (locale === "hi") return hi_sync_changes_error_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_error_toast(inputs)
	return en_sync_changes_error_toast(inputs)
});